function Logo() {
  return (
    <span className="h-full ps-logo-text z-50 pm-logo flex flex-col justify-center items-center">
      RS.
    </span>
  );
}

export default Logo;
